import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_INJECTED_COMPONENTS':
      return action.injected
    default:
      return state
  }
}

export default reducer
